import { FormControl } from '@mui/material';
import { Fragment, useState } from 'react';
import { Controller, FieldValues } from 'react-hook-form';
import { SelectFormStyled } from 'v3/shared/components/DialogDataSelect/styles';
import { DialogRadioDataSelect } from 'v3/shared/components/DialogRadioDataSelect';
import { StyledArrowDropDownIcon } from 'v3/shared/components/Inputs/DropdownSelectFormController/styles';
import { ErrorMessage } from 'v3/shared/components/Inputs/styles/defaultStyles';
import { IData, SelectRadioFormControllerProps } from './types';

export const SelectRadioFormController = <T extends FieldValues>({
  formControl,
  formControlName,
  label,
  defaultValues,
  enumType = false,
  setValue,
  onChangeSelect,
}: SelectRadioFormControllerProps<T>) => {
  const [selectItem, setSelectItem] = useState<string>('');
  const [open, setOpen] = useState<boolean>(false);

  const getDefaultValues: IData[] = [
    { key: '-', value: '' },
    ...(enumType
      ? Object.keys(defaultValues).map((key: string) => ({
          key: key,
          value: defaultValues[key],
        }))
      : defaultValues.map((item: { key: string; value: string }) => ({ key: item.key, value: item.value }))),
  ].filter((item, index, self) => index === self.findIndex((name) => name.key === item.key));

  const setSelect = (item: string) => {
    setSelectItem(item);
    setValue(formControlName, item as any, { shouldValidate: true });
    onChangeSelect?.(item);
  };

  const getKeyByValue = (value: string): string => {
    if (!value) return '';
    return getDefaultValues.find((item: IData) => item.key === value)?.key || '';
  };

  return (
    <Fragment>
      <DialogRadioDataSelect
        setOpen={setOpen}
        open={open}
        data={getDefaultValues}
        setSelectItem={setSelect}
        title={label}
      />

      <Controller
        name={formControlName}
        control={formControl}
        render={({ field: { name, value }, fieldState: { error } }) => {
          return (
            <FormControl fullWidth>
              <SelectFormStyled
                inputProps={{ 'data-testid': `select-form-controller-${name}` }}
                fullWidth
                label={label}
                name={name}
                autoComplete="off"
                placeholder="Selecione"
                onClick={() => setOpen(true)}
                onKeyDown={() => setOpen(true)}
                value={getKeyByValue(selectItem || value) || ''}
                InputProps={{
                  readOnly: true,
                  endAdornment: <StyledArrowDropDownIcon />,
                }}
              />
              <ErrorMessage>{error?.message}</ErrorMessage>
            </FormControl>
          );
        }}
      />
    </Fragment>
  );
};
